// Kleine Rückfrage vor einer Handlung mit Folgen (Rückgängig, Sperre aufheben, Fristen einschalten). Ein Fenster mit Text und zwei
// Knöpfen; Escape bricht ab.
import { useState, type ReactNode } from "react";
import { Dialog } from "../components/Dialog";
import { fehlerInfo } from "../components/Fehler";

export function Bestaetigen({ titel, offen, text, knopf, gefahr = false, onJa, onNein }: {
  titel: string;
  offen: boolean;
  text: ReactNode;
  knopf: string;
  gefahr?: boolean;
  onJa: () => Promise<void> | void;
  onNein: () => void;
}) {
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);
  const ja = async () => {
    setLaeuft(true);
    setFehler(null);
    try {
      await onJa();
    } catch (e) {
      setFehler(fehlerInfo(e).text);
    } finally {
      setLaeuft(false);
    }
  };
  return (
    <Dialog
      titel={titel}
      offen={offen}
      onSchliessen={onNein}
      breite={440}
      fuss={
        <>
          <button type="button" className="knopf" onClick={onNein}>
            Abbrechen
          </button>
          <button type="button" className={`knopf ${gefahr ? "knopf--gefahr" : "knopf--primaer"}`} disabled={laeuft} onClick={() => void ja()}>
            {knopf}
          </button>
        </>
      }
    >
      <div>{text}</div>
      {fehler ? <div className="hinweis hinweis--fehler">{fehler}</div> : null}
    </Dialog>
  );
}
